export const theme = {
  breakpoints: {
    smallPhone: 360,
    phone: 430,
    tablet: 820,
    desktopHd: 1920,
    tv4k: 3840,
  },

  colors: {
    bordoAccent: "#b77dff",
    bordoAccentDark: "#8a52e0",
    bordoCore: "#5b3596",
    deepBlack: "#2b1a45",
    outerSpace: "#2b1a45",
    white: "#ffffff",
    goldMain: "#ffe08f",
    goldHover: "#fff5cf",
    goldSoft18: "rgba(255, 224, 143, 0.28)",
    goldSoft10: "rgba(255, 224, 143, 0.2)",
    goldSoft08: "rgba(255, 224, 143, 0.15)",
    goldSoft025: "rgba(255, 224, 143, 0.08)",
    testimonialBg: "rgba(255, 255, 255, 0.08)",
    testimonialBgHover: "rgba(255, 255, 255, 0.12)",
    testimonialBorder: "rgba(255, 216, 107, 0.34)",
    testimonialBorderHover: "rgba(255, 216, 107, 0.56)",
    testimonialText: "#ffffff",
    testimonialSubtext: "#b0b0b0",
    testimonialAccent: "#667eea",
    testimonialAccentLight: "rgba(102, 126, 234, 0.1)",
    testimonialAccentBorder: "rgba(102, 126, 234, 0.5)",
    cardBg1: "rgba(183, 125, 255, 0.2)",
    cardBg2: "rgba(135, 83, 218, 0.28)",
    cardBg3: "rgba(72, 44, 118, 0.34)",
    cardBgHover1: "rgba(205, 156, 255, 0.28)",
    cardBgHover2: "rgba(156, 106, 232, 0.36)",
    cardBgHover3: "rgba(90, 58, 138, 0.44)",
    navBorderGold26: "rgba(255, 241, 184, 0.34)",
    navBorderGold38: "rgba(255, 241, 184, 0.46)",
    navBorderGold48: "rgba(255, 241, 184, 0.58)",
    navBorderGold18: "rgba(255, 241, 184, 0.24)",
    navDividerGold50: "rgba(255, 241, 184, 0.64)",
    navBarUnderline: "rgba(255, 216, 107, 0.2)",
    navLoginBorder: "rgba(255, 216, 107, 0.42)",
    navLoginBg: "rgba(255, 216, 107, 0.2)",
    navLoginBgHover: "rgba(255, 216, 107, 0.32)",
    navLinkBarBgTop: "rgba(255, 245, 214, 0.1)",
    navLinkBarBgBottom: "rgba(90, 54, 145, 0.4)",
    navLinkBarBgHoverTop: "rgba(255, 245, 214, 0.18)",
    navLinkBarBgHoverBottom: "rgba(112, 68, 178, 0.56)",
    navToggleBg: "rgba(72, 42, 116, 0.88)",
    navBackdrop: "rgba(24, 12, 40, 0.38)",
    navShellBg: "rgba(42, 22, 70, 0.46)",

    // ─── Akcenty ───
    pinkAccent: "#ff4fa3",
    pinkSoft40: "rgba(255, 79, 163, 0.4)",

    // ─── Tekst – warianty przezroczystości ───
    textMuted: "rgba(255, 255, 255, 0.8)",
    textSubtle: "rgba(255, 255, 255, 0.75)",
    textFaded: "rgba(255, 255, 255, 0.62)",
    textDim: "rgba(255, 255, 255, 0.68)",
    textPlaceholder: "rgba(255, 255, 255, 0.3)",

    // ─── Overlay & tła ───
    overlayBg: "rgba(18, 8, 32, 0.58)",
    overlayDense: "rgba(16, 8, 28, 0.72)",
    inputBg: "rgba(255, 255, 255, 0.1)",
    inputBgLight: "rgba(255, 255, 255, 0.14)",
    headBg: "rgba(255, 255, 255, 0.08)",

    // ─── Cienie ───
    shadowLight: "rgba(0, 0, 0, 0.3)",
    shadowMedium: "rgba(0, 0, 0, 0.4)",
    shadowHeavy: "rgba(0, 0, 0, 0.5)",

    // ─── Gradienty paneli ───
    panelTableStart: "rgba(188, 132, 255, 0.46)",
    panelTableMid: "rgba(110, 70, 182, 0.76)",
    panelTableEnd: "rgba(60, 36, 98, 0.84)",
    panelFormStart: "rgba(205, 152, 255, 0.5)",
    panelFormMid: "rgba(122, 80, 194, 0.8)",
    panelFormEnd: "rgba(68, 42, 106, 0.86)",
    panelDialogStart: "rgba(214, 170, 255, 0.88)",
    panelDialogEnd: "rgba(82, 52, 124, 0.92)",

    // ─── Złoto – warianty alfa (rozszerzenie goldSoft) ───
    goldSoft04: "rgba(255, 224, 143, 0.1)",
    goldSoft05: "rgba(255, 224, 143, 0.12)",
    goldSoft06: "rgba(255, 224, 143, 0.14)",
    goldSoft12: "rgba(255, 224, 143, 0.2)",
    goldSoft15: "rgba(255, 224, 143, 0.26)",
    goldSoft20: "rgba(255, 224, 143, 0.34)",
    goldSoft25: "rgba(255, 224, 143, 0.42)",
    goldSoft30: "rgba(255, 224, 143, 0.48)",
    goldSoft40: "rgba(255, 224, 143, 0.58)",

    // ─── Bordo – warianty alfa ───
    bordoSoft10: "rgba(155, 77, 255, 0.16)",
    bordoSoft20: "rgba(155, 77, 255, 0.26)",
    bordoSoft25: "rgba(155, 77, 255, 0.32)",
    bordoSoft30: "rgba(155, 77, 255, 0.38)",
    bordoSoft35: "rgba(155, 77, 255, 0.44)",
    bordoSoft50: "rgba(155, 77, 255, 0.58)",
    bordoSoft90: "rgba(155, 77, 255, 0.9)",

    // ─── Przyciski neutralne ───
    btnNeutralBg: "rgba(255, 255, 255, 0.04)",
    btnNeutralBgHover: "rgba(255, 255, 255, 0.08)",
    btnNeutralBorder: "rgba(255, 255, 255, 0.15)",

    // ─── Powierzchnie i sekcje ───
    surfaceStrong: "rgba(68, 42, 106, 0.62)",
    surfaceMid: "rgba(92, 58, 136, 0.46)",
    surfaceSoft: "rgba(255, 255, 255, 0.08)",
    surfaceSoftAlt: "rgba(255, 255, 255, 0.12)",
    surfaceSoftHover: "rgba(255, 255, 255, 0.16)",
    footerStart: "rgba(102, 66, 150, 0.9)",
    footerEnd: "rgba(56, 34, 92, 0.88)",
    footerText: "rgba(255, 245, 220, 0.9)",

    // ─── Statusy ───
    statusSuccess: "#4ade80",
    statusSuccessBg: "rgba(74, 222, 128, 0.2)",
    statusDanger: "#fb7185",
    statusDangerBg: "rgba(251, 113, 133, 0.22)",
    statusWarning: "#fbbf24",
    statusWarningBg: "rgba(251, 191, 36, 0.2)",

    // ─── Toast ───
    toastSuccessBg: "rgba(30, 100, 50, 0.9)",
    toastSuccessBorder: "rgba(80, 200, 100, 0.4)",
    toastSuccessText: "#dfd",
    toastErrorText: "#fdd",
  },

  fonts: {
    main: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  },

  /** Nawigacja — odstępy i typografia (import jako `theme` w styled) */
  navbar: {
    heightDesktop: "90px",
    minHeightTablet: "64px",
    minHeightPhone: "60px",
    gridColumnGapDesktop: "clamp(10px, 2vw, 24px)",
    gridColumnGapTablet: "10px",
    gridColumnGapPhone: "8px",
    paddingXDesktop: "clamp(8px, 3vw, 50px)",
    paddingXTablet: "14px",
    paddingXPhone: "10px",
    navRightGapDesktop: "clamp(6px, 1.5vw, 12px)",
    navRightGapTablet: "clamp(4px, 1.2vw, 8px)",
    menuToggleSize: "44px",
    menuToggleRadius: "10px",
    menuToggleFontSize: "1.24rem",
    drawerTop: "78px",
    drawerBackdropTopTablet: "72px",
    drawerWidth: "min(92vw, 360px)",
    drawerMaxWidth: "360px",
    drawerPadding: "14px 18px 16px",
    drawerBorderRadius: "16px",
    drawerViewportOffset: "72px",
    linksBarGap: "clamp(4px, 1.5vw, 30px)",
    linksBarPaddingX: "8px",
    linksBarGapTablet: "clamp(3px, 0.8vw, 8px)",
    linksBarGapPhone: "clamp(2px, 0.6vw, 5px)",
    linksDrawerGapTablet: "16px",
    linksDrawerGapPhone: "14px",
    linksDrawerMarginBottom: "clamp(8px, 2vw, 12px)",
    linkBarFontWeight: 600,
    linkDrawerFontWeight: 500,
    linkBarFontSize: "clamp(0.48rem, 1.2vw, 0.90rem)",
    linkBarLetterSpacing: "clamp(0.5px, 0.08vw, 1px)",
    linkBarPadding: "clamp(2px, 0.3vw, 4px) clamp(4px, 0.7vw, 7px)",
    linkBarRadius: "10px",
    linkBarFontSizeTablet: "clamp(0.48rem, 0.9vw, 0.68rem)",
    linkBarLetterSpacingTablet: "0.6px",
    linkBarPaddingTablet: "clamp(2px, 0.2vw, 3px) clamp(3px, 0.5vw, 5px)",
    linkBarFontSizePhone: "clamp(0.44rem, 0.75vw, 0.56rem)",
    linkBarLetterSpacingPhone: "0.5px",
    linkBarPaddingPhone: "clamp(2px, 0.1vw, 3px) clamp(3px, 0.4vw, 5px)",
    linkDrawerFontSize: "0.9rem",
    linkDrawerLetterSpacing: "1.1px",
    linkDrawerPadding: "2px 0",
    linkDrawerFontSizePhone: "0.84rem",
    linkDrawerLetterSpacingPhone: "0.9px",
    linkDrawerPaddingTablet: "1px 0",
    linkDrawerPaddingPhone: "1px 0",
    linkSeparatorWidth: "18px",
    linkSeparatorOffsetY: "-9px",
    loginGap: "clamp(5px, 1vw, 10px)",
    loginPadding: "clamp(6px, 1.2vw, 10px) clamp(10px, 2vw, 18px)",
    loginFontSize: "clamp(0.8rem, 1.8vw, 0.95rem)",
    loginLetterSpacing: "0.3px",
    loginGapTablet: "clamp(4px, 1.5vw, 8px)",
    loginPaddingTablet: "clamp(6px, 1.5vw, 9px) clamp(10px, 2.5vw, 16px)",
    loginFontSizeTablet: "clamp(0.75rem, 2.2vw, 0.9rem)",
    loginGapPhone: "clamp(4px, 2vw, 6px)",
    loginPaddingPhone: "clamp(5px, 1.8vw, 8px) clamp(8px, 2.8vw, 14px)",
    loginFontSizePhone: "clamp(0.7rem, 2.8vw, 0.85rem)",
    loginIconFontSize: "clamp(0.9rem, 1.8vw, 1.1rem)",
    loginIconFontSizeTablet: "clamp(0.85rem, 2.2vw, 1rem)",
    loginIconFontSizePhone: "clamp(0.8rem, 2.8vw, 0.95rem)",
    socialGap: "20px",
    socialGapTablet: "14px",
    socialGapPhone: "12px",
    socialIconSize: "1.3rem",
    socialIconSizeTablet: "1.18rem",
    socialIconSizePhone: "1.08rem",
    mobileLoginMarginTop: "18px",
    mobileLoginPaddingY: "clamp(14px, 3vw, 18px)",
    mobileLoginMarginTopPhone: "16px",
    mobileLoginPaddingYPhone: "clamp(12px, 2.5vw, 16px)",
    mobileSocialMarginTop: "14px",
    mobileSocialPaddingTop: "12px",
  },
};
